import {useContext} from 'react';

import {AppBarLoadingContext} from '@/components/global/providers/AppBarLoadingProvider';

const useAppBarLoading = () => useContext(AppBarLoadingContext);

export default useAppBarLoading;
